import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'

interface Args {
  description: string
}

interface Signature {
  Args: Args
  Element: HTMLElement
}

export const BookModalDescription: TOC<Signature> = <template>
  {{#if @description}}
    <section ...attributes>
      <h5 class="text-dusty-black-250 mb-1 uppercase">
        {{t "bookLibrary.bookAttr.description"}}:
      </h5>
      <p class="mb-3">{{@description}}</p>
    </section>
  {{/if}}
</template>

export default BookModalDescription
